import { render, staticRenderFns } from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=template&id=4fd63c1c&scoped=true"
import script from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=script&lang=js"
export * from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=script&lang=js"
import style0 from "./ObservacionesResultadoC3DialogComponent.vue?vue&type=style&index=0&id=4fd63c1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd63c1c",
  null
  
)

export default component.exports